module.exports = __webpack_public_path__ + "static/media/receipt.932f701f.png";